<template>
  <div class="login-container">
    <div class="login-box">
      <h1>商户管理系统登录</h1>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名</label>
          <input type="text" id="username" placeholder="请输入用户名" v-model="username" />
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <input type="password" id="password" placeholder="请输入密码" v-model="password" />
        </div>
        <button type="submit" class="login-button">登录</button>
      </form>
    </div>
  </div>
</template>

<script>
import { postAction } from '@/api/manage'
export default {
  name: 'Login',
  data() {
    return {
      username:'',
      password:'',
      loading: false,
      redirect: undefined,
      show:false,
      oldpassword:'',
      newpassword:'',
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    changepassword(){
       this.show = true
    },
    handleLogin() {
        this.loading = true
        const url = '/clientCtr/login'
        postAction( url, {username:this.username,password:this.password }).then( res => {
        this.loading = false
        if( res.data.code == 200) {
           localStorage.setItem("clientname", this.username)
           this.$router.push({name: 'clienthome'})
        }
        else{
          this.$message.warning(res.data.mag)
        }
        }).catch(() => {
            this.loading = false
        })
    },
    changeSubmit(){
        this.loading = true
        const url = '/oa/updatePassword'
        postAction( url, {username:this.username,oldpassword:this.oldpassword,newpassword:this.newpassword,type:'client' }).then( res => {
        this.loading = false
        if( res.data.code == 200) {
          this.$message.success('修改成功')
          this.show = false
        }
        else{
          this.$message.warning(res.data.msg)
        }
        }).catch(() => {
            this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-box {
  background-color: #ffffff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px;
  text-align: center;
}

h1 {
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #555;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.login-button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.login-button:hover {
  background-color: #0056b3;
}
</style>

